export default "__VITE_ASSET__766d8a98__"